import React from "react";
import { Button, Container } from "react-bootstrap";
import Navbar from "../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import "./Menu.css";
import Footer2 from "../footer/Footer";
import { Link } from "react-router-dom";

function Menu() {
  const { t } = useTranslation();
  return (
    <>
      <Navbar></Navbar>

      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <Container style={{ marginBottom: "100px" }}>
        <h1 style={{ textAlign: "center", fontSize: "60px" }}> {t("titlemenu")}</h1>
        <hr />

        <Row style={{ marginTop: "40px", marginBottom: "40px" }}>
          <Col xs={12} md={6} className="button-container">
            <Button
              as="a"
              href="https://www.leggimenu.it/menu/trattoriadaangelo"
              target="_blank"
              rel="noreferrer"
              className="custom-button"
              id="fuorimenu1"
            >
              {t("ristorante")}
            </Button>
          </Col>

          <Col xs={12} md={6} className="button-container">
            <Link to="/fuorimenu" className="custom-link" style={{ fontFamily: "cormourant" }}>
              <Button className="custom-button " id="fuorimenu1">
                {t("fuorimenu")}
              </Button>
            </Link>
          </Col>
        </Row>
        <hr />
      </Container>
      <Footer2 />
    </>
  );
}

export default Menu;
